import { render, staticRenderFns } from "./TradingTestFailedByStrategy.vue?vue&type=template&id=836ef390"
import script from "./TradingTestFailedByStrategy.vue?vue&type=script&lang=ts"
export * from "./TradingTestFailedByStrategy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports